import OBR from '@owlbear-rodeo/sdk';

export const COMBAT_SYNC_CHANNEL = 'com.lordofdisndat.dcc/combat-sync';

export interface CombatSyncSignal {
  type: 'combat-sync';
  reason?: string;
}

export function isCombatSyncSignal(value: unknown): value is CombatSyncSignal {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  return record.type === 'combat-sync' && (record.reason === undefined || typeof record.reason === 'string');
}

export async function broadcastCombatSync(reason?: string): Promise<void> {
  await OBR.broadcast.sendMessage(
    COMBAT_SYNC_CHANNEL,
    { type: 'combat-sync', ...(reason ? { reason } : {}) },
    { destination: 'ALL' },
  );
}
